import {Component, OnInit} from '@angular/core';
import {ContactUsformrule} from './contactUsformrule';  
import {ContactUsservice} from '../services/contactUsservice.service';

import { LocalStorageService } from 'angular-web-storage';

import { AppConstants  } from './../AppConstants';

import {Router} from '@angular/router';

@Component({
  selector: 'ContactUs',
  templateUrl: './ContactUs.component.html',
  styleUrls: ['../app.component.css'],
  providers: [ContactUsservice]
})

export class ContactUs implements OnInit {
    contactUsformrule: ContactUsformrule[];

   commonUrl:string;
   projectId:string;
  apiKey:string;

  constructor(private router: Router,
              private contactUsservice: ContactUsservice,
              private local: LocalStorageService) {
         this.commonUrl = AppConstants.commonUrl;
        this.projectId = AppConstants.projectId;
        this.apiKey = this.local.get('logedInUser').apiKey;

  }

  /**
   * Gets the existing users
   */
  getAll(): void {
    this.contactUsservice.getAll()
      .then(contactUsformrule => {
        console.log(contactUsformrule);
        let response = JSON.parse(JSON.stringify(contactUsformrule));
        this.contactUsformrule = response.response;
      });
  }

  ngOnInit(): void {
    this.getAll();
  }

  update(id: string): void {
    this.router.navigate(['/contactUsUpdate', id]);
  }

  remove(id: string): void {
    if(confirm("Are you sure to delete this")) {
      this.contactUsservice.remove(id)
        .then(() => {
          this.getAll();
      });
    }
  }

  viewDetail(id: string): void {
    this.router.navigate(['/detail', id]);
  }


  
}
